const state = {
  token: localStorage.getItem('token') || '',
  userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}')
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
    localStorage.setItem('token', token)
  },
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
  },
  LOGOUT(state) {
    state.token = ''
    state.userInfo = {}
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
  }
}

const actions = {
  login({ commit }, { username, password }) {
    return new Promise((resolve, reject) => {
      // 模拟登录 - 支持用户名和手机号登录
      const mockUsers = JSON.parse(localStorage.getItem('mockUsers') || '[]')
      
      // 默认管理员账号
      if (username === 'admin' && password === 'admin123') {
        const token = 'mock-token-' + Date.now()
        const userInfo = {
          id: 1,
          username: 'admin',
          name: '管理员',
          email: 'admin@example.com',
          role: 'admin'
        }
        commit('SET_TOKEN', token)
        commit('SET_USER_INFO', userInfo)
        resolve()
        return
      }
      
      // 查找已注册用户（支持用户名或手机号登录）
      const user = mockUsers.find(u => 
        (u.username === username || u.phone === username) && u.password === password
      )
      
      if (user) {
        const token = 'mock-token-' + Date.now()
        const userInfo = {
          id: user.id,
          username: user.username,
          name: user.name,
          phone: user.phone,
          email: user.email,
          role: user.role || 'user'
        }
        commit('SET_TOKEN', token)
        commit('SET_USER_INFO', userInfo)
        resolve()
      } else {
        reject(new Error('用户名/手机号或密码错误'))
      }
    })
  },
  
  // 注册
  register({ commit }, userData) {
    return new Promise((resolve, reject) => {
      const mockUsers = JSON.parse(localStorage.getItem('mockUsers') || '[]')
      
      // 检查用户名是否已存在
      if (mockUsers.find(u => u.username === userData.username)) {
        reject(new Error('用户名已存在'))
        return
      }
      
      // 检查手机号是否已注册
      if (mockUsers.find(u => u.phone === userData.phone)) {
        reject(new Error('该手机号已注册'))
        return
      }
      
      // 创建新用户
      const newUser = {
        id: Date.now(),
        username: userData.username,
        phone: userData.phone,
        password: userData.password,
        name: userData.name || userData.username,
        email: userData.email || `${userData.username}@example.com`,
        role: 'user',
        createTime: new Date().toISOString()
      }
      
      mockUsers.push(newUser)
      localStorage.setItem('mockUsers', JSON.stringify(mockUsers))
      
      // 自动登录
      const token = 'mock-token-' + Date.now()
      const userInfo = {
        id: newUser.id,
        username: newUser.username,
        name: newUser.name,
        phone: newUser.phone,
        email: newUser.email,
        role: newUser.role
      }
      commit('SET_TOKEN', token)
      commit('SET_USER_INFO', userInfo)
      
      resolve(userInfo)
    })
  },
  
  logout({ commit }) {
    return new Promise((resolve) => {
      commit('LOGOUT')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

